
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { Environment } from '@/login/enums/Environment';
import { getEnvironmentData, ssoAuthenticate } from '@/login/clients/Authentication';
import { EnvironmentData, SsoAuthenticationData } from '@/login/clients/types/Authentication';
import { getModule } from 'vuex-module-decorators';
import LoginStore from '@/login/store';
import { store } from '@/store';

getModule(LoginStore, store);

@Component
export default class Sso extends Vue {
	@Prop()
	private readonly code!: string;

	private environment!: EnvironmentData;

	async created(): Promise<void> {
		if (!this.code) {
			this.redirectToLoginPage();
			return;
		}

		await this.setCurrentEnvironment();

		this.authenticate();
	}

	redirectToLoginPage(): void {
		this.$router.push({ name: '' });
	}

	async setCurrentEnvironment(): Promise<void> {
		const environmentData = await getEnvironmentData();

		if (!environmentData) {
			await this.redirectToLoginPage();
		}

		this.environment = environmentData;
	}

	get domain(): string {
		return `https://klogin-sso-${this.environment.env}.auth.us-west-2.amazoncognito.com`;
	}

	get redirectUri(): string {
		if (this.environment.env === Environment.PROD) {
			return 'https://my.kasasaonline.com/';
		}

		return `https://my.${this.environment.env}.kasasaonline.com/`;
	}

	authenticate(): void {
		// The amplify library will grab the code form the URL query. We don't need to pass it in.
		const authData: SsoAuthenticationData = {
			clientId: this.environment.clientId,
			region: this.environment.region,
			userPoolId: this.environment.userPoolId,
			env: this.environment.env,
			domain: this.domain,
			redirectUri: this.redirectUri,
		};

		ssoAuthenticate(authData);
	}
}
